<template>
  <div class="mt-1 dsd-distributions">
      <distributions-header 
      :getDistributionDescription="getDistributionDescription"
      :openModal="forwardOpenModal"
      :getDistributionTitle="getDistributionTitle"
      :showDownloadUrls="showDownloadUrls"
      :isUrlInvalid="isUrlInvalid"
      :showPublisher="showPublisher"
      :embed="embed"
      @displayVisualisation="handleDisplayVisualisation"
      @track-link="handleTrackLink"
    />
    <div class="download-all-wrapper">
    <download-all-distributions v-if="!downloadAllTop" :getDistributionDescription="getDistributionDescription"
      :openModal="forwardOpenModal" :getDistributionTitle="getDistributionTitle" :showDownloadUrls="showDownloadUrls"
      :isUrlInvalid="isUrlInvalid" />
      </div>
    <download-as-modal />
    <distribution-visualisation-slot v-if="showDistibutionVisualisation && showVisualisation"
      ref="visualisationComponent" 
      :key="componentKey" 
      class="mb-4" 
      :title="previewedDistTitle"
      :downloadUrl="previewedDistDownloadUrl" 
      :format="previewedDistFormat"
      :compressFormat="previewedDistCompressFormat">
    </distribution-visualisation-slot>
  </div>
</template>

<script>
import { has, isNil } from "lodash";
import {
  getTranslationFor,
} from "@piveau/piveau-hub-ui-modules";
import { mapGetters } from "vuex";
import DistributionsHeader from "./ECDistributionsHeader.vue";
import ECDistributionDownloadAsModal from "./ECDistributionDownloadAsModal.vue";
export default {
  name: 'ECDistributions',
  components: {
    DistributionsHeader,
    DownloadAsModal: ECDistributionDownloadAsModal,
  },
  props: {
    openModal: Function,
    expandedDistributions: Array,
    expandedDistributionDescriptions: Array,
    displayedDistributions: Array,
    distributions: Object,
    setDistributionsDisplayCount: Function,
    isDistributionsAllDisplayed: Boolean,
    pages: Object,
    showDownloadUrls: Function,
    getDistributionFormat: Function,
    distributionFormatTruncated: Function,
    getDistributionTitle: Function,
    distributionVisibleContent: Array,
    distributionExpandedContent: Array,
    distributionDescriptionIsExpanded: Function,
    distributionDescriptionIsExpandable: Function,
    distributionIsExpanded: Function,
    showObject: Function,
    showNumber: Function,
    showDownloadDropdown: Function,
    showLicence: Function,
    showLicensingAssistant: Function,
    filterDateFormatEU: Function,
    showArray: Function,
    showObjectArray: Function,
    getVisualisationLink: Function,
    isOnlyOneUrl: Function,
    getDownloadUrl: Function,
    trackGoto: Function,
    showAccessUrls: Function,
    replaceHttp: Function,
    previewLinkCallback: Function,
    toggleDistribution: Function,
    toggleDistributionDescription: Function,
    increaseNumDisplayedDistributions: Function,
    nonOverflowingIncrementsForDistributions: Function,
    isUrlInvalid: Function,
    openIfValidUrl: Function,
    showTooltipVisualiseButton: Function,
    appendCurrentLocaleToURL: Function,
    showPublisher: Boolean,
    embed: Boolean,
  },
  data() {
    return {
      componentKey: 0,
      downloadAllTop: this.$env.content.datasetDetails.bulkDownload.buttonPosition === "top",
      // previewedDistributionTitle: this.getDistributionTitle(this.displayedDistributions[0]),
      showDistibutionVisualisation: false,
      previewedDistributionTitle: "",
      previewedDistDownloadUrl: "",
      previewedDistFormat: "",
      previewedDistCompressFormat: "",
      selectedDistribution: null,
      showVisualisation: this.$env.content.datasetDetails.distributions.showVisualisation,
    };
  },
  computed: {
    ...mapGetters('datasetDetails', [
      'getLanguages',
      'getCatalog',
    ]),
  },
  methods: {
    forwardOpenModal(...args) {
      if (typeof this.$props.openModal === 'function') {
        this.$props.openModal(...args);
      }
    },
handleDisplayVisualisation(downloadUrl) {
  console.log('ECDistributions: Received displayVisualisation event with URL:', downloadUrl);
  
  const distribution = this.findDistributionByUrl(downloadUrl);
  
  if (distribution) {
    this.previewedDistTitle = this.getDistributionTitle(distribution);
    this.previewedDistDownloadUrl = downloadUrl;
    this.previewedDistFormat = distribution.format?.id || 'csv';
    // Fix: Sicherstellen, dass compressFormat ein String ist oder leer bleibt
    this.previewedDistCompressFormat = distribution.compressFormat || '';
    this.showDistibutionVisualisation = true;
    this.componentKey += 1;

    this.$nextTick(() => {
      const visualisationComponent = this.$refs.visualisationComponent;
      if (visualisationComponent) {
        visualisationComponent.$el.scrollIntoView({ behavior: 'smooth' });
      }
    });
  } else {
    console.warn('Distribution not found for URL:', downloadUrl);
  }
},
    
    handleTrackLink(url, type) {
      console.log('ECDistributions: Tracking link:', url, type);
      // Implementieren Sie hier Ihre Link-Tracking-Logik
    },
    
    findDistributionByUrl(url) {
      // Suchen Sie in den verfügbaren Distributionen nach der, die diese URL hat
      if (!this.displayedDistributions) return null;
      
      return this.displayedDistributions.find(dist => 
        dist.downloadUrls?.includes(url) || 
        dist.accessUrl?.includes(url)
      );
    },
    getDistributionDescription(distribution) {
      return (has(distribution, 'description') && !isNil(distribution.description)) ? getTranslationFor(distribution.description, this.$route.query.locale, this.getLanguages) : '-';
    },
    selectDistribution(dist) {
      this.previewedDistTitle = dist.title;
      this.previewedDistDownloadUrl = dist.url;
      this.previewedDistFormat = dist.format;
      this.previewedDistCompressFormat = dist.compressFormat ? dist.compressFormat : '';
      this.showDistibutionVisualisation = true;
      this.componentKey += 1;  // kill and rerender with new values

      // scroll to visualisation component
      this.$nextTick(() => {
        const visualisationComponent = this.$refs.visualisationComponent;
        if (visualisationComponent) {
          visualisationComponent.$el.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.download-all-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.catalogue-label {
  white-space: pre-line;
}

.cursor-pointer {
  cursor: pointer;
}

.tag-color {
  background-color: var(--tag-color);
}

.subjectBg {
  background-color: #196fd2;
}

.btn-color {
  &:hover {
    background-color: #196fd2;
    border-color: #196fd2;
  }
}

.download-all-btn {
  min-width: 100px;
  height: 31px;
}

/*** BOOTSTRAP ***/
button:focus {
  outline: 0;
}

.spinner-grow {
  width: 20px;
  height: 20px;
}

/*** FONT AWESOME ICONS ***/
.fa-check-square {
  color: #28a745;
  width: 16px;
  height: 16px;
}

/*** MATERIAL ICONS ***/
%modal-icon {
  font-size: 18px;
  cursor: default;
}

.help-icon {
  @extend %modal-icon;
}

.check-icon {
  @extend %modal-icon;
  color: #28a745;
}

.material-icons.small-icon {
  font-size: 20px;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.keywords {

  &__item {
    position: relative;
  }

  &__actions {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    height: 100%;
    z-index: 11;
  }
}

.sectionList {
  list-style-type: '→ ';
  margin-left: 6.5%;
}

@media only screen and (max-width: 991px) {
  .sectionList {
    margin-left: 0;
  }
}
</style>
